var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content add-warehouse-charge-dialog",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.dialogLabel,
        width: "810px",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-button",
        {
          staticStyle: { "margin-left": "25px", width: "80px" },
          attrs: { type: "primary" },
          on: { click: _vm.copy }
        },
        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_OneClickCopy")))]
      ),
      _c("cargo-ag-grid", {
        staticStyle: {
          "margin-top": "15px",
          "margin-left": "25px",
          "margin-bottom": "15px",
          width: "95%",
          height: "252px"
        },
        attrs: {
          "show-side-bar": false,
          "column-defs": _vm.columnDefs,
          "row-data": _vm.rowData,
          "grid-options": _vm.gridOptions
        },
        on: { rowDataChanged: _vm.rowDataChanged }
      }),
      _c("span", [_vm._v(_vm._s(_vm.copyNote))]),
      _c(
        "div",
        {
          staticStyle: { "text-align": "center" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "130px" },
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                  _vm.$emit("close")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }